/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {Button, Stack} from '@mui/material';
import Typography from '@mui/material/Typography';
import {GridOverlay, type GridSlotProps} from '@mui/x-data-grid-premium';

declare module '@mui/x-data-grid-premium' {
  interface NoRowsOverlayPropsOverrides {
    onReset: () => void;
  }
}

export const SuperTableErrorOverlay = ({onReset}: GridSlotProps['noRowsOverlay']) => {
  return (
    <GridOverlay>
      <Stack spacing={1} alignItems={'center'} justifyContent={'center'}>
        <Typography variant={'h6'} color={'error'}>
          Error: Failed to load data
        </Typography>
        <Typography variant={'body2'}>Please check your network and try again.</Typography>
        <Button size={'small'} onClick={onReset}>
          Reset
        </Button>
      </Stack>
    </GridOverlay>
  );
};
